export const SECOND_STEP_TITLE = "kiedy_nas_odwiedzisz";
export const THIRD_STEP_TITLE = "szczegoly_rezerwacji";
export const FOURTH_STEP_TITLE = "dodatki";
export const END_STEP_TITLE = "podsumowanie_rezerwacji";
